import { useMutation } from 'react-query';
import { forgotPassword } from '../../../store/apiCalls/authentication';

function OnForgotPassword(sucessHandler,setError) {
    return {
        ...useMutation(forgotPassword, {
            onSuccess: (data) => { sucessHandler(data) 
            setError('')
            },
            onError: (errMsg) => {
            setError(errMsg.response.data.message||'Something went wrong, Please try again after sometime')              
            },
        })
    }
}

export {
    OnForgotPassword,
}